import {apiClient} from 'core/apiClient';
import {ApiFilters, ApiPaging, ApiSortings} from 'types/api';

import {
    DeclarationDetails,
    DeclarationPaginationContent,
    DeclarationsAccessors,
    DeclarationsGridRawRow,
} from 'types/declarations';

const DECLARATION_URL = '/customs/declaration';

const modifyParams = (params: {
    sortings: ApiSortings;
    filters: ApiFilters;
    paging: ApiPaging;
    searchField?: string;
}) => {
    const receiptedAt = params.filters.find(
        (filter) => filter.id === DeclarationsAccessors.receiptedAt,
    );
    if (receiptedAt && Array.isArray(receiptedAt?.value)) {
        const receiptedAtFlattered = receiptedAt.value[0];
        if (receiptedAt?.value?.length) {
            // @ts-ignore
            receiptedAt.value = receiptedAtFlattered;
        }
    }
};

export async function fetchDeclarationsGrid(params: {
    sortings: ApiSortings;
    filters: ApiFilters;
    paging: ApiPaging;
    searchField?: string;
}) {
    const {pageSize, pageNumber} = params.paging;
    const mappedPaging = {pageSize, pageNumber: pageNumber + 1};
    modifyParams(params);

    return (
        await apiClient.post<DeclarationPaginationContent<DeclarationsGridRawRow>>(
            `${DECLARATION_URL}/page`,
            {...params, paging: mappedPaging},
        )
    ).data;
}

export async function fetchDeclarationDetails(params: {id: string}) {
    return (await apiClient.get<DeclarationDetails>(`${DECLARATION_URL}/${params.id}`)).data;
}

export async function setDeclarationReviewStatus(params: {id: string; gd_number: string}) {
    return (
        await apiClient.put<DeclarationDetails>(`${DECLARATION_URL}/review/${params.id}`, null, {
            params: {gd_number: params.gd_number},
        })
    ).data;
}

export async function setDeclarationConfirmStatus(payload: {id: string; confirm: boolean}) {
    const params = {confirm: payload.confirm};
    return (
        await apiClient.put<DeclarationDetails>(`${DECLARATION_URL}/confirm/${payload.id}`, null, {
            params,
        })
    ).data;
}
